module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-area"
  }, [_c('div', {
    staticClass: "container-fluid"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid centered text-justify"
  }, [_c('h1', {
    staticClass: "centered"
  }, [_vm._v("Контакты")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('contacts', {
    attrs: {
      "height": 500
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00a6bab0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contacts.vue
// module id = 217
// module chunks = 1